import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';

import { IMoveMoneyReviewResponse } from '../../../types';
import { endpointManager } from '../../../services/endpoint.service';

interface IPostMfaResend {
    mfaData: IMoveMoneyReviewResponse | null;
}

export const postMfaResend = () => {
  const { postMfaResendUrl } = endpointManager();
  return useMutation(
    'postMfaResend',
    async ({ mfaData }: IPostMfaResend) => {
      const res = await httpService.post(postMfaResendUrl(), { ...mfaData });
      return res.data;
    },
  );
};
